function injectStyle (ssrContext) {
  require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":0,\"remove\":true}!css-loader!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-55d3e8a3\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"museUiTheme\":\"'/usr/src/app/node_modules/muse-ui/src/styles/themes/variables/default.less'\"}}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LifePostInfo.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./LifePostInfo.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-55d3e8a3\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./LifePostInfo.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-55d3e8a3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/LifeStyle/LifePostInfo/LifePostInfo.vue
// module id = 1247
// module chunks = 1